<!--
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: smallWhite
 * @Date: 2022-10-18 14:05:31
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-05-17 11:26:47
 * @FilePath: /admin-main/src/layouts/logo/index.vue
-->
<template>
  <div class="logo-wrapper">
    <img v-if="showLogo"
      class="logo-img"
      :src="require('../../assets/aiHead.png')" />
    <transition
      v-if="showTitle"
      name="el-fade-in-linear">
      <span
        v-show="!state.isCollapse || alwaysShow"
        class="logo-title">管理系统</span>
    </transition>
  </div>
</template>

<script>
import store from '../store/index'
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    alwaysShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: store.state
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.logo-wrapper {
  height: $logoHeight;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .logo-img {
    width: 30px;
  }
  .logo-title {
    margin-left: 5px;
    font-weight: bold;
  }
}
</style>
